import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ErrorState = () => {
  return (
    <div className="text-center py-8">
      <AlertCircle className="mx-auto h-12 w-12 text-red-500 mb-4" />
      <h3 className="text-xl font-medium text-gray-900 mb-2">Error Loading Articles</h3>
      <p className="text-gray-600 mb-4">There was a problem loading the articles. Please try again later.</p>
      <Button 
        variant="outline" 
        className="mt-4"
        onClick={() => window.location.reload()}
      >
        Refresh Page
      </Button>
    </div>
  );
};